import { RouteObject } from 'react-router-dom';
import { TeamOutlined } from '@ant-design/icons';
import CustomerManagementView from './views/CustomerManagementView';
import CustomerDetailViewPage from './views/CustomerDetailView';

export const CustomerManagementModule = {
  name: 'customer-management',
  displayName: 'Customer Management',
  icon: <TeamOutlined />,
  routes: [
    {
      path: '/customers/manage',
      element: <CustomerManagementView />,
    },
    {
      path: '/customers/manage/:branch/:custNo',
      element: <CustomerDetailViewPage />,
    },
  ] as RouteObject[],
  permissions: ['CUSTOMER_MANAGEMENT'],
};
